import { render, staticRenderFns } from "./registerDocumentsStep.vue?vue&type=template&id=f81b86a8"
import script from "./registerDocumentsStep.vue?vue&type=script&lang=js"
export * from "./registerDocumentsStep.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./register.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./registerDocumentsStep.vue?vue&type=style&index=2&id=f81b86a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports